import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    marginBottom: pxToRem(16),
  },
  actionRequiredTitle: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
    marginTop: pxToRem(12),
  },
  actionRequiredBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
    selectors: {
      b: {
        fontWeight: 600,
      },
    },
  },
  actionRequiredBoldBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 600,
  },
  actionText: {
    paddingBottom: pxToRem(8),
  },
  reviewButton: {
    selectors: {
      '&.ms-Link': {
        padding: 0,
        color: theme.palette.themePrimary,
        fontSize: pxToRem(14),
      },
    },
    display: 'block',
    marginTop: pxToRem(11),
  },
  chevronRight: {
    position: 'relative',
    top: pxToRem(1),
    marginLeft: pxToRem(5),
  },
  details: {
    margin: 0,
    padding: 0,
    selectors: {
      li: {
        color: theme.palette.neutralDark,
        display: 'list-item',
        fontSize: pxToRem(14),
        listStyle: 'inside',
        position: 'relative',
      },
    },
    marginTop: pxToRem(8),
  },
  agreementName: {
    color: theme.palette.neutralDark,
    fontSize: pxToRem(14),
    fontWeight: 600,
    marginTop: pxToRem(8),
  },
});
